import dayjs from "dayjs";
import * as React from "react";
import { CheckoutStartDateInput } from "@components/student/CheckoutStartDateInput";
import { useCheckoutStartDateInputInfoQuery, } from "@graphql";
import useStudentCheckoutData from "@/local-state/hooks/useStudentCheckoutData";
export const CheckoutStartDateInputContainer = ({ value, subscription, schedule, onChange }) => {
    const scheduleData = useStudentCheckoutData();
    const { loading, data, error } = useCheckoutStartDateInputInfoQuery({
        variables: {
            lessonTemplatesIds: "lessonTemplatesIds" in schedule ? schedule.lessonTemplatesIds : [],
        },
        onCompleted: ({ subscriptionStartDates }) => {
            var _a, _b;
            const firstTrialLessonTime = (_b = (_a = scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.trialLesson) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.time;
            const firstSubscriptionStartDate = subscriptionStartDates[0];
            const newStartDate = dayjs(firstTrialLessonTime || firstSubscriptionStartDate);
            onChange(newStartDate);
        },
    });
    if (loading) {
        return null;
    }
    if (error) {
        throw error;
    }
    if (value) {
        if (data) {
            const dates = data.subscriptionStartDates.map(date => dayjs(date));
            return (React.createElement(CheckoutStartDateInput, { availableDates: dates, subscription: subscription, value: value, onChange: onChange }));
        }
        throw new Error("Empty render");
    }
    return null;
};
